import { logger } from '../logger/index.ts';

export const lockfileLogger = logger('lockfile');
